import Reflux from 'reflux';
import ShowData from 'shared/data/Show';
import ScheduleData from 'shared/data/Schedule';
import ListData from 'shared/data/List';
import { DisplayTypes } from 'shared/constants/FlowConstants';

let async = { asyncResult: true },
  ShowFormActions = Reflux.createActions({
    updateField: {},
    submit: {},
    create: async,
    populate: {},
    clear: {},
  });

ShowFormActions.create.listenAndPromise(
  (teamId, eventId, show, templateId, folderParentId) => {
    var handler = ShowData.create;

    if (show.displayType === DisplayTypes.schedule)
      handler = ScheduleData.create;
    if (show.displayType === DisplayTypes.list) handler = ListData.create;

    return handler(teamId, eventId, show, templateId, folderParentId);
  },
);

export default ShowFormActions;
